import { render } from "./UiTheCover.vue?vue&type=template&id=a224bcc8&scoped=true"
import script from "./UiTheCover.vue?vue&type=script&lang=js"
export * from "./UiTheCover.vue?vue&type=script&lang=js"

import "./UiTheCover.vue?vue&type=style&index=0&id=a224bcc8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a224bcc8"

export default script